module.exports = __webpack_public_path__ + "static/scale-model-of-casa-navarro-state-historic-site-in-san-antonio-texas-bfecd74c9d1932194d882b4903f1eaca.png";